import { render, staticRenderFns } from "./FormAlertsComponent.vue?vue&type=template&id=3b5493dc&"
import script from "./FormAlertsComponent.vue?vue&type=script&lang=js&"
export * from "./FormAlertsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports